import { useAuthAppStore } from "@/store/stores/authStore";

export class PRApprovalMatrixService {
  async getAllEntities({ client, queryStr }) {
    var response = await client.get({
      route: "/approval-matrix/get-all-entities-paged",
      params: queryStr,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
        "Content-Type": "application/json",
      },
      successCallback: () => {},
      errorCallback: () => {},
    });

    return response;
  }

  async putEntities({ client, data, successCallback, errorCallback }) {
    await client.put({
      route: "/approval-matrix/update-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async createEntities({ client, data, successCallback, errorCallback }) {
    await client.post({
      route: "/approval-matrix/create-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async deleteEntity({ client, params, successCallback, errorCallback }) {
    await client.delete({
        route: "/approval-matrix/delete-entity",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Authorization": `Bearer ${useAuthAppStore().token}`
        },
        params: params,
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }

  async getAllEntitiesPaged({ prApprovalMatrixServiceClient, params }) {
    
    params.filter = JSON.stringify([
      "PurchaseRequestNumber", "=", params.prNumber,
    ]);

    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-all-entities-paged",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),

      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getEntityByPkey({ prApprovalMatrixServiceClient, params }) {
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-entity-by-pkey",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getFindByPurchaseRequestNumber({ prApprovalMatrixServiceClient, params }) {
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-request-number",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getFindByPurchaseRequestNumberWithComplex({ prApprovalMatrixServiceClient, params, complex }) {
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-request-number",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": complex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getFindStagesByPurchaseRequestNumbers({
    prApprovalMatrixServiceClient,
    params,
    complexCode
  }) {
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-request-numbers",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": complexCode,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getFindByPurchaseOrderNumber({ prApprovalMatrixServiceClient, params }) {
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-request-number",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async replaceApprover({ prApprovalMatrixServiceClient, data }) {
    var response = await prApprovalMatrixServiceClient.put({
      route: "/approval-matrix-step/replace-approver",
      data: data,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function () {},
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });
    return response;
  }

  async getApproveUrlByRequestNumbers({ prApprovalMatrixServiceClient, params, dataComlexCode }) {
    
    var response = await prApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-approval-url-by-request-numbers",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": dataComlexCode,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }
}
